import { StateService } from "@uirouter/angularjs";
import angular, { IQService, IServiceProvider } from "angular";
import {
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../records/forms/formView";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import { LookupEntry, LookupManagementService, vsServiceName } from "./service";

export const vsProviderName = `${vsServiceName}Provider`;

export class LookupManagementServiceProvider implements IServiceProvider {
  private readonly configs: { [name: string]: LookupEntry } = {};

  addLookup(name: string, entry: LookupEntry) {
    this.configs[name] = entry;
  }

  $get: any = [
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    FormViewServiceName,
    "$state",
    "$q",
    "$injector",
    (
      recordGridViewService: RecordGridViewService,
      columnDefinitionService: ColumnDefinitionService,
      formViewService: FormViewService,
      $state: StateService,
      $q: IQService,
      $injector: angular.auto.IInjectorService
    ) =>
      new LookupManagementService(
        this.configs,
        recordGridViewService,
        columnDefinitionService,
        formViewService,
        $state,
        $q,
        $injector
      ),
  ];
}

/*
private readonly recordGridViewService: RecordGridViewService,
private readonly formViewService: FormViewService,
private readonly columnDefinitionService: ColumnDefinitionService,
private readonly $state: StateService,
private readonly $q: IQService
*/
